export default {
  // 統計卡片
  todayAlertCount: '今日預警數',
  scanCountAlert: '掃碼次數預警',
  crossRegionAlert: '跨地區預警數',
  vsYesterday: '較昨天',
  // 搜索區
  qrcode: '二維碼',
  qrcodePlaceholder: '請輸入二維碼編號',
  alertTime: '預警時間',
  startTime: '開始時間',
  endTime: '結束時間',
  alertType: '預警類型',
  alertTypePlaceholder: '請選擇',
  alertStatus: '預警狀態',
  alertStatusPlaceholder: '請選擇',
  // 預警類型
  typeScanCount: '次數預警',
  typeCrossRegion: '跨地區預警',
  // 預警狀態
  statusAlerting: '預警中',
  statusResolved: '已解除',
  statusDisabled: '已禁用',
  // 操作按鈕
  export: '導出',
  // 表格列
  colQrcode: '二維碼',
  colUserInfo: '用戶信息',
  colProductInfo: '產品信息',
  colAlertRule: '預警規則',
  colAlertStatus: '預警狀態',
  colAlertTime: '預警時間',
  colAction: '操作',
  // 操作列
  resolveAlert: '解除預警',
  disableQrcode: '禁用二維碼',
  // 解除預警彈窗
  resolveTitle: '解除預警',
  resolveContent: '確定要解除該預警嗎？',
  resolveRemark: '處理備註',
  resolveRemarkPlaceholder: '請輸入處理備註（選填）',
  // 禁用二維碼彈窗
  disableTitle: '禁用二維碼',
  disableContent: '確定要禁用該二維碼嗎？禁用後掃碼將提示無效。',
  disableReason: '禁用原因',
  disableReasonPlaceholder: '請輸入禁用原因',
  disableReasonRequired: '請輸入禁用原因',
  // 空狀態
  emptyText: '暫無預警記錄',
};
